import { ErrorMessage } from "@hookform/error-message";
import React from "react";
import { UseFormReturn } from "react-hook-form";

import { Button } from "../../../components/button";

interface IScanForm {
  loading: boolean;
  submit: any;
  form: UseFormReturn<any, any>;
}

export const ScanForm: React.FC<IScanForm> = ({ loading, submit, form }) => {
  return (
    <div className=" ">
      <div className="flex flex-wrap  -m-3 mb-2">
        <div className="w-full p-3">
          <p className="mb-1.5 font-medium text-base text-coolGray-800">
            Produit
          </p>
          <input
            className="w-full input"
            type="text"
            {...form.register("produitId", { required: "produitId required" })}
            placeholder="produitId"
            disabled
          />
        </div>
      </div>

      <div className="flex ">
        <div className="w-1/2 mr-1 ">
          <div className="w-full mb-2">
            <p className="label">prix</p>
            <input
              className="w-full input"
              {...form.register("price")}
              placeholder="xx"
            />

            <ErrorMessage
              errors={form.formState?.errors}
              name="price"
              render={({ message }) => (
                <p className="error-message">{message}</p>
              )}
            />
          </div>
        </div>
        <div className="w-1/2 ml-1">
          <div className="w-full mb-2">
            <p className="label">Quantité</p>
            <input
              className="w-full input"
              {...form.register("quantity")}
              placeholder="quantity"
            />

            <ErrorMessage
              errors={form.formState?.errors}
              name="quantity"
              render={({ message }) => (
                <p className="error-message">{message}</p>
              )}
            />
          </div>
        </div>
      </div>

      <Button
        disabled={!form.formState.isValid}
        loading={loading}
        onClick={submit}
      >
        Valider
      </Button>
    </div>
  );
};
